import React from 'react';
import cardstyles from "./cards.module.css"

const ChooseCards = (props) => {
    return (
       <> 
       <div className={cardstyles.cardWrapper}>
           <img src={props.src} alt={props.alt} /> 
          <h2>{props.h2}</h2>
       </div>
     </>
    );
}
 
 
export default ChooseCards;